export const AuthId = {
    ManageBooking: 'manageBooking',
    OnlineCheckin: 'onlineCheckin',
    FlightSurvay: 'flightSurvay'
}